import moment from 'moment-timezone'
import { LOAD_STATE, STOP_TYPE } from 'apps/fleet-planner/constants/loads'
import { IDriver } from 'apps/fleet-planner/types/driver'
import { getDefaultStop } from './getDefaultStop'

export interface CreateLoadDefaultValues {
  driver?: IDriver
  range?: [string, string]
}

interface IGetDefaultLoadStateProps {
  defaultValues?: CreateLoadDefaultValues
  timezone?: string
}

/**
 * Utility function to create the default state
 */
export const getDefaultLoadState = ({
  defaultValues,
  timezone = moment.tz.guess(),
}: IGetDefaultLoadStateProps) => {
  const { driver, range = [] } = defaultValues || {}

  // Add drivers
  const drivers = []
  if (driver?.id) drivers.push(driver)

  const [startAtPickup, startAtDropoff] = range || {}

  return {
    customer: undefined,
    customerContact: undefined,
    customerNotes: '',
    notes: '',
    dispatcher: {},
    drivers,
    externalId: undefined,
    isSample: false,
    miles: undefined,
    mcNumber: undefined,
    motorCarrier: {},
    rate: undefined,
    status: LOAD_STATE.Pending,
    trailerId: undefined,
    trailerLength: undefined,
    trailerType: undefined,
    truckId: undefined,
    stops: [
      /** Pickup */
      getDefaultStop({
        defaultValues: {
          stopType: STOP_TYPE.pickup,
          stopSequence: 1,
          startAt: startAtPickup,
        },
        timezone,
      }),
      /** Dropoff */
      getDefaultStop({
        defaultValues: {
          stopType: STOP_TYPE.dropoff,
          stopSequence: 1,
          startAt: startAtDropoff,
        },
        timezone,
      }),
    ],
  }
}
